import {
  Component,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { McAppComponentBase, McRedirectService, McSessionTimeoutService } from '@medrio/common';
import { TranslateService } from '@ngx-translate/core';
import { ContextService, IntercomUrlService } from 'projects/cross-study-portal-lib/src/public-api';
import { filter, map } from 'rxjs/operators';
import { MenuOption } from './interfaces/menu-option';
import { MenuOptionService } from './services/menu-option.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends McAppComponentBase implements OnInit {
  @ViewChild('sidebar', { static: true }) sidebar = null;
  public changesMade = false;
  public basePath = '/';
  showSidenav = true;
  footerText = '';
  footerUrl = '';
  googleTagManagerId = '';

  get navOptions(): MenuOption[] {
    return this.menuOptionService.getMenuOptions();
  }

  constructor(public titleService: Title,
    public translateService: TranslateService,
    public redirectService: McRedirectService,
    private menuOptionService: MenuOptionService,
    public timeoutsApiService: McSessionTimeoutService,
    private intercomUrlService: IntercomUrlService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private context: ContextService,
    private renderer: Renderer2) {
    super(titleService, translateService, redirectService, timeoutsApiService);
  }

  ngOnInit(): void {
    this.setSidenavLayout();
    this.setFooter();
    this.googleTagManagerId = this.context.instance.googleTagManagerId;
    if (this.context.instance.isProduction) {
      this.loadGoogleAnalyticScript();
    }
    this.loadIntercomScript(this.intercomUrlService.get());
  }

  private setSidenavLayout(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        // returns true (shows sidenav) if there isn't 'sidenav' property in data payload
        let childRoute = this.activatedRoute.firstChild;

        while (childRoute) {
          if (childRoute.firstChild) {
            childRoute = childRoute.firstChild;
          } else if (childRoute.snapshot.data && Object.prototype.hasOwnProperty.call(childRoute.snapshot.data, 'sidenav')) {
            return childRoute.snapshot.data.sidenav;
          } else {
            return true;
          }
        }
        return true;
      }),
    ).subscribe((sidenav: boolean) => {
      this.showSidenav = sidenav;
    });
  }

  private setFooter() {
    this.footerText = this.context.instance.footerText;
    this.footerUrl = this.context.instance.footerUrl;
  }

  private loadIntercomScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = true;
    script.defer = false;
    body.appendChild(script);
  }

  public loadJsScript(renderer: Renderer2, contentScript: string): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = contentScript;
    renderer.appendChild(document.getElementsByTagName('head')[0], script);
    return script;
  }

  private loadGoogleAnalyticScript() {
    const scriptContent = `(function (w, d, s, l, i) {
      w[l] = w[l] || []; 
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${this.context.instance.googleTagManagerId}');`;
    this.loadJsScript(this.renderer, scriptContent);
  }
}
